module.exports = __webpack_public_path__ + "img/chat.a35fc987.webp";